import List from "./list/list.store";
import Individual from "./individual/individual.store";

export default {
  modules: {
    List,
    Individual,
  },
};
